// components/SubjectRow.tsx
import React from "react";
import { Tag } from "antd";
import CustomButton from "components/Common/ui/CustomButton";
import { getSubjectLabelFromCode } from "utils/schoolUtils";
import { useTranslation } from "react-i18next";
import NumberHours from "components/Common/ui/NumberHours";
import useClassLevelSubjectSetting from "../hooks/useClassLevelSubjectSetting";

type Props = {
  item: any;
  onDelete: (id: string) => void;
};

const SubjectRow: React.FC<Props> = ({ item, onDelete }) => {
  const { t } = useTranslation();
  const { updateItemClassLevelSubjectSetting, createItemClassLevelSubjectSetting } = useClassLevelSubjectSetting();

  return (
    <div className="row py-1 align-items-center" key={item.id}>
      <div className="col-6 d-flex align-items-center gap-2">
        <span
          style={{
            display: "inline-block",
            width: 12,
            height: 12,
            borderRadius: "50%",
            backgroundColor: item.subject?.colorCode || "#ccc",
          }}
        />
        <span>{getSubjectLabelFromCode(item.subject?.code, t) || item.subject?.name}</span>
      </div>

      <div className="col-2">
        <Tag color="blue">{item.coefficient}</Tag>
      </div>
      <div className="col-2">
        <NumberHours
          settingId={item.subject?.classLevelSetting?.id}
          value={item.subject?.classLevelSetting?.numberHours}
          compact
          classLevelId={item.classLevelId}
          subjectId={item.subject?.id}
          onCreateSetting={createItemClassLevelSubjectSetting}
          onPatched={(nextHours, newSetting) => {
            if (newSetting) {
              // Create the classLevelSetting object if it was just created
              item.subject.classLevelSetting = newSetting;
            } else if (item.subject?.classLevelSetting) {
              // Update existing setting
              item.subject.classLevelSetting.numberHours = nextHours;
            }
          }}
        />
      </div>

      <div className="col-2">
        <CustomButton
          disabled={!item.instanceId}
          variant="primary"
          size="sm"
          onClick={() => onDelete(item.id)}
        >
          <i className="ti ti-trash me-2" />
          {t("delete")}
        </CustomButton>
      </div>
    </div>
  );
};

export default SubjectRow;
